<template lang="pug">
.jobs-table-component
  .table-wrapper
    .scrollable
      table.has-actions.table-hover.table
        thead
          tr
            th Job ID
            th Date
            th Status
            th Assignees
            th
        tbody
          tr(
            v-for="job in allJobs"
            :key="'job-' + job.id"
          )
            td
              a(
                href="#"
                @click.prevent="onEditJob(job)"
              ) {{ job.summary }}
            td
              .d-flex.align-items-center
                i.hi.hi-refresh.mr-5(
                  v-tooltip
                  :title="scheduleTooltip(job.schedule)"
                  :class="{ 'show-icon': jobIsRecurrent(job) }"
                )
                div
                  | {{ $filters.formatDate(job.startsAt) }}
                  br
                  | {{ $filters.formatTimeRangeNoSeconds(job.startsAt, job.stopsAt).toLowerCase() }} {{ job.timeZoneAbbr }}
            td.status-cell
              small.job-status.label.mr-5(:class="statusStyleClass(job)")
                | {{ statusName(job) }}
            td
              HubAvatar.avatar-overlaps(
                v-for="assignee in jobAssignees(job)"
                :key="'assignee-' + assignee.id"
                v-tooltip="{ delay: { hide: 0 } }"
                :users-avatars="allUsersAvatars"
                :title="assignee.name"
                :user-id="assignee.id"
                avatar-style="speck"
              )
              span.more-members-badge.light(v-if="jobAssigneesCount(job) > 3") +{{ jobAssigneesCount(job) - 3 }}
            td
              .dropdown.table-actions-dropdown
                a.btn.btn-sm.btn-default.dropdown-toggle(
                  href="#"
                  data-toggle="dropdown"
                  role="button"
                )
                  | Actions
                  i.hi.hi-caret.hi-10
                ul.dropdown-menu.dropdown-menu-right
                  li
                    a.action.show-job-action(
                      v-track:click.capture="{ label: 'View job', scope: 'Work order jobs table' }"
                      @click="$emit('show-job', job)"
                    ) View job
                  li
                    a.action.edit-job-action(
                      v-track:click.capture="{ label: 'Edit job', scope: 'Work order jobs table' }"
                      @click="onEditJob(job)"
                    ) Edit job
                  li(v-if="canDestroySchedules")
                    a.action.delete-job-action(
                      v-track:click.capture="{ label: 'Delete job', scope: 'Work order jobs table' }"
                      @click="$emit('delete-job', job)"
                    ) Delete job
                  li(v-if="isJobCompleted(job)")
                    a.action.reopen-job-action(
                      v-track:click.capture="{ label: 'Reopen job', scope: 'Work order jobs table' }"
                      @click="$emit('reopen-job', job)"
                    ) Reopen job
                  li(v-else)
                    a.action.complete-job-action(
                      v-track:click.capture="{ label: 'Mark job as completed', scope: 'Work order jobs table' }"
                      @click="$emit('complete-job', job)"
                    ) Mark job as completed
      WorkOrdersNoJobsData(v-if="showEmptyState")
      //- TODO: Add view recent or future jobs link action in "slot"
  AppPagination(
    v-if="allJobs.length"
    :pagination="pagination"
    :resource="{ one: 'Job', many: 'Jobs' }"
    @page-changed="onPageChanged"
  )
</template>

<script>
import { get } from 'lodash-es';
import { RecurringJobs, WorkOrderJobActions } from '~/mixins';
import { mapInertiaProps } from '~/utils/inertia';
import WorkOrdersNoJobsData from '~/components/work_orders/WorkOrdersNoJobsData.vue';

export default {
  name: 'WorkOrdersJobsTable',
  components: {
    WorkOrdersNoJobsData,
  },
  mixins: [RecurringJobs, WorkOrderJobActions],
  props: {
    allJobs: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['show-job', 'delete-job', 'reopen-job', 'complete-job', 'edit-job', 'page-changed'],
  computed: {
    ...mapInertiaProps({
      pagination: 'pagination',
      allUsersAvatars({ wo_assignees: woAssignees }) {
        return woAssignees.reduce((avatars, user) => avatars.set(user.id, user.avatar), new Map());
      },
    }),
    showEmptyState() {
      return !this.allJobs.length;
    },
  },
  methods: {
    onEditJob(job) {
      this.$emit('edit-job', job);
    },
    onPageChanged(page) {
      this.$emit('page-changed', page);
    },
    jobAssignees(job) {
      return (job.assignees || []).slice(0, 3);
    },
    jobAssigneesCount(job) {
      return (job.assignees || []).length;
    },
    statusName(job) {
      const status = job.status;

      return status ? status.name : '';
    },
    statusStyleClass(job) {
      const status = job.status;

      return status ? 'label-' + status.symbol : '';
    },
    isJobCompleted(job) {
      return get(job, 'status.name') === 'Completed';
    },
  },
};
</script>
